import React from 'react'
import {
  Nav,
  Navbar,
  NavItem
} from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { LinkContainer } from 'react-router-bootstrap'

const Header = () => (
  <Navbar inverse collapseOnSelect>
    <Navbar.Header>
      <Navbar.Brand>
        <Link to="/">CTV-Dashboard</Link>
      </Navbar.Brand>
      <Navbar.Toggle />
    </Navbar.Header>
    <Navbar.Collapse>
      <Nav>
        <LinkContainer to="/builds">
          <NavItem>Builds</NavItem>
        </LinkContainer>
        <LinkContainer to="/launch-control">
          <NavItem>Launch Control</NavItem>
        </LinkContainer>
        <li role="presentation">
          <Link target="_self" to="/launcher.html">Launcher</Link>
        </li>
      </Nav>
    </Navbar.Collapse>
  </Navbar>
)
export default Header


// WEBPACK FOOTER //
// ./src/components/Header.js